import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  padding: 20px;
  gap: 20px;
`;

export const Container = styled.div`
  background-color: #fff;
  display: flex;
  grid-gap: 13px;
  align-items: center;
  padding: 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.07);
  border-radius: 10px;
  justify-content: space-between;
`;

export const PageButtons = styled.div`
  background-color: transparent;
  border-radius: 8px;
  max-width: 300px;
  height: 30px;
  display: grid;
  overflow: hidden;
  grid-template-columns: ${({ repeat }) =>
    repeat ? `repeat(${repeat}, 1fr)` : "repeat(7, 1fr)"};
`;

export const Button = styled.button`
  border: none;
  border-radius: 0;
  background: transparent;
  color: #8f8f8f;
  font-size: 19px;
  min-width: calc(300px / 7);
  font-weight: 700;
  line-height: 21.78px;
  cursor: pointer;
  &:hover {
    color: ${({ active }) => !active && "#3380ff"};
  }
  &:focus {
    outline: none;
  }
  ${({ active }) =>
    active &&
    `
    color: #3380ff;
  `}
`;

export const ChangeButtons = styled.div`
  width: 90px;
  height: 30px;
  border-radius: 8px;
  background-color: white;
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
`;

export const ChangeButton = styled.button`
  width: 30px;
  height: 30px;
  color: ${({ color }) => color};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  background-color: #e3f0ff;
  border-radius: 6px;
  border: none;
  transition: all ease 300ms;
  color: #444;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:not(:disabled):hover {
    background: #3380ff;
    color: #fff;
  }
  &:disabled {
    background: #f5f5f5;
  }
`;
